export default __webpack_public_path__ + "static/media/sort-alpha-asc.9df173a2.svg";